export function createFormData(formData, data, previousKey) {
  if (data instanceof Object) {
    Object.keys(data).forEach(key => {
      const value = data[key]

      key = previousKey ? `${previousKey}[${key}]` : key

      if (value instanceof File) {
        return formData.append(key, value)
      }
      if (value instanceof Object && !Array.isArray(value)) {
        return createFormData(formData, value, key)
      }

      if (Array.isArray(value)) {
        if (value && value.length === 0) {
          formData.append(`${key}`, JSON.stringify([]))
        } else {
          value.forEach((val, index) => {
            if (val instanceof Object && !Array.isArray(val)) {
              return createFormData(formData, val, `${key}[${index}]`)
            }
            formData.append(`${key}[]`, JSON.stringify(val))
          })
        }
      } else {
        formData.append(key, JSON.stringify(value))
      }
    })
  }
}
